import { cn } from "@/lib/utils";
import { FilterCombobox } from "../../FilterCombobox";
import { MigrationStatus, MigrationStatusColors, MigrationStatusFileLabels, MigrationStatusIcons } from "../../../../models/MigrationStatus";
import { Label } from "@/components/ui/label";
import { filterComboboxClassName } from "../TableStyles";

interface FileStatusFilterProps {
  value: string | null;
  onChange: (newValue: string | null) => void;
  excludeStatuses?: MigrationStatus[];
  className?: string;
}

export const FileStatusFilter = ({
  value,
  onChange,
  excludeStatuses = [MigrationStatus.InProgress],
  className,
}: FileStatusFilterProps) => (
  <div className={cn(filterComboboxClassName, className)}>
    <Label className="text-xs font-semibold text-muted-foreground">Status</Label>
    <FilterCombobox
      value={value}
      onChange={onChange}
      placeholder="Status"
      options={Object.values(MigrationStatus)
        .filter((v) => !excludeStatuses.includes(v as MigrationStatus))
        .map((status) => ({
          value: status,
          label: MigrationStatusFileLabels[status as MigrationStatus],
          color: MigrationStatusColors[status as MigrationStatus],
          icon: MigrationStatusIcons[status as MigrationStatus],
        }))}
    />
  </div>
);
